import { IconButton } from '@material-ui/core';
import { Card } from '@material-ui/core';
import AtlasIcon from '@material-ui/icons/Airplay';
import HyperGateIcon from '@material-ui/icons/Cast';
import AddIcon from '@material-ui/icons/AddCircle';
import DeleteIcon from '@material-ui/icons/DeleteForever';
import SmartLocksIcon from '@material-ui/icons/LockOpen';
import RepeatIcon from '@material-ui/icons/Repeat';
import GuestGroupIcon from '@material-ui/icons/SupervisorAccountOutlined';
import { Form, Row } from '@sketchpixy/rubix';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import _ from 'lodash';
import React from 'react';
import InfiniteScroll from 'react-infinite-scroller';
import { connect } from 'react-redux';
import { Field, FieldArray, change, reduxForm } from 'redux-form';
import { COMPANY_NOTIFICATIONS_ATLAS_STATES, COMPANY_NOTIFICATIONS_BATTERY_LEVELS, COMPANY_NOTIFICATIONS_BATTERY_STATES, COMPANY_NOTIFICATIONS_CREDENTIALS_STATES, COMPANY_NOTIFICATIONS_ELEMENTS_USAGE_LEVELS, COMPANY_NOTIFICATIONS_ELEMENTS_USAGE_STATES, COMPANY_NOTIFICATIONS_GATEWAY_STATES, COMPANY_NOTIFICATIONS_REPEAT_STATES, RED } from '../../_config/consts.js';
import { isUserWithoutEmail, isValidEmail } from '../../_config/utils.js';
import * as GuestActions from '../../redux/actions/guest.actions';
import * as PlatformUserActions from '../../redux/actions/platformUsers.actions';
import * as InstallersActions from '../../redux/actions/installers.actions.js';
import CompanyReportIconCustom from '../CustomIcons/CompanyReportIconCustom.jsx';
import ListLoadingView from '../ListLoadingView.jsx';
import MDButton from '../MDButton/MDButton.jsx';
import FormFlatContainer from './Elements/FormFlatContainer.jsx';
import MDRadioButtonsGroupField from './Elements/MDRadioButtonsGroup/MDRadioButtonsGroupField.js';
import CustomField from './Fields/CustomField.jsx';
import EmailAutocompleteField from './Fields/EmailAutocompleteField.jsx';
import SelectableField from './Fields/SelectableInput/SelectableField.jsx';
import GuestCredentialIconCustom from '../CustomIcons/GuestCredentialIconCustom.jsx';
import WalletIconCustom from '../CustomIcons/WalletIconCustom.jsx';

const onRenderEmails = (props) => {
  const { fields, formData, onInitializeNewEmail, usersOptions = [], meta } = props;
  const numberOfEmails = _.size(fields);
  const hasFieldsError = meta && meta.error;
  
  return (
    <div style={{}}>
      <div style={{ marginBottom: 15, paddingLeft: 5 }}>
        <h4 style={{ color: '#3f3f3f', marginBottom: 5, fontWeight: 'bold', fontSize: 16 }}>
          <Entity entity="notificationEmailsList" />
          <span style={{ color: RED, marginLeft: 5, fontSize: 18 }}>*</span>
        </h4>
      </div>
      
      {fields && fields.map((email, index) => (
        <div key={`emails${index + 1}`} elevation={2} style={{width:'fit-content', marginBottom: 15}}>
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', justifyContent: 'space-between', paddingRight: 10 }}>
            <div style={{ paddingLeft: 0, width: 400 }}>
              <Field
                name={`emails[${index}]`}
                component={EmailAutocompleteField}
                placeholder="Enter email address..."
                usersOptions={usersOptions}
              />
            </div>
            <IconButton
              style={{ marginLeft: 30, marginTop: 0 }}
              disabled={props.disabled}
              onClick={(e) => {
                e.stopPropagation();
                if (!formData.isEditing) {
                  fields.remove(index);
                }
              }}
            >
              <DeleteIcon style={{ color: RED, fontSize: 20 }} />
            </IconButton>
          </div>
        </div>
      ))}
      {!props.disabled ? (
        <Card
          style={{ height: 40, marginBottom: 20, padding: 10, display: 'flex', flexDirection: 'row', alignItems: 'center', width:'fit-content', cursor: 'pointer', border: hasFieldsError ? `2px solid ${RED}` : '1px solid #e0e0e0' }}
          className="card card-rounded"
          onClick={() => {
            fields.push({});
            onInitializeNewEmail(numberOfEmails);
          }}
        >
          <AddIcon style={{ color: hasFieldsError ? RED : '#4DB6AC', marginRight: 15, fontSize: 25 }} />
          <h4 style={{ fontWeight: 'bold', marginTop:0, marginBottom:0, color: hasFieldsError ? RED : '#3f3f3f' }}>
            <Entity entity="newResourceReservationAutomaticEmail" />
          </h4>
        </Card>
      ) : null}
    </div>
  );
}

const validate = (values) => {
  const errors = {};
  
  if (!values.gatewayMode) {
    errors.gatewayMode = 'required';
  }
  
  if (!values.batteryMode) {
    errors.batteryMode = 'required';
  }
  
  if (!values.atlasMode) {
    errors.atlasMode = 'required';
  }
  
    if (!values.repeatMode) {
    errors.repeatMode = 'required';
  }
  
  if (!values.credentialsMode) {
    errors.credentialsMode = 'required';
  }

  if (values.gatewayMode===COMPANY_NOTIFICATIONS_GATEWAY_STATES.ON && (!values.gatewayOfflineForMinutes || values.gatewayOfflineForMinutes<=0)) {
    errors.gatewayOfflineForMinutes = 'required';
  }

  if (values.repeatMode===COMPANY_NOTIFICATIONS_REPEAT_STATES.ON && (!values.sameNotificationAfterHours || values.sameNotificationAfterHours<=0)) {
    errors.sameNotificationAfterHours = 'required';
  }

  if (values.credentialsMode===COMPANY_NOTIFICATIONS_CREDENTIALS_STATES.ON && (!values.credentialsWillExpireInHours || values.credentialsWillExpireInHours<=0)) {
    errors.credentialsWillExpireInHours = 'required';
  }

  if (!values.emails || !_.isArray(values.emails) || values.emails.length === 0) {
    errors.emails = 'required';
  }
  if (values.emails && values.emails.length > 0) {
    values.emails.forEach((email,i) => {
      if (!isValidEmail(email, true)) {
        if (!errors.emails) 
          errors.emails = [];
        errors.emails[i] = 'invalid';
      }
    });
  }

  return errors;
};

@reduxForm({ form: 'SystemStatusReportForm', validate })
@connect(state => ({ form: state.form.SystemStatusReportForm, user: state.user, platformUsers: state.platformUsers, installers: state.installers}))
class SystemStatusReportForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      usersOptions: [],
      userSelected: null,
      loading: false,
    };
  }

  async componentDidMount() {
    this.onFilterUsers(undefined)
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.form?.initial && this.props.form?.initial) {
      this.onFilterUsers(undefined);
    }
  }
  
  async onFilterUsers(value) {
    const { dispatch, platformUsers: { data: { content: platformUsersData }}, installers: { data: { content: installersData }} } = this.props;
    const usersToFilter = [...platformUsersData, ...installersData ];
    const users = value?
      usersToFilter.filter(e=>(`${e.firstname} ${e.lastname} ${isUserWithoutEmail(e) ? '': ` - ${e.email}`}`).toLowerCase().includes(value.toLowerCase())):
      usersToFilter;
    const userOptions = _.map(users, user => ({ value: user, label: `${user.firstname} ${user.lastname} ${isUserWithoutEmail(user) ? '': ` - ${user.email}`}` }));
    const filteredUsersOptions = _.filter(userOptions, userOption => !userOption.value.companyNotificationsEnabled);
    this.setState({ usersOptions: filteredUsersOptions });
  }
  
  onSelectUser(user) {
    if (user && user.value)
      this.setState({ userSelected: user.value });
  }


  onInitializeNewEmail(emailId, fieldName) {
    const { dispatch } = this.props;    
    dispatch(change('SystemStatusReportForm', `${fieldName}[${emailId}]`, ""));
  }

  render() {
    const { form, formStyle, platformUsers: { data: { content: platformUsersData }}, user } = this.props;
    const { userSelected, usersOptions, loading } = this.state
    
    const formData = form && form.values;

    const gatewayOptions = [
      {
        label: <Entity entity="companyNotificationsGatewayOFF" />,
        value: COMPANY_NOTIFICATIONS_GATEWAY_STATES.OFF,
      },
      {
        label: <Entity entity="companyNotificationsGatewayON" />,
        value: COMPANY_NOTIFICATIONS_GATEWAY_STATES.ON,
      },
    ];
    const batteryOptions = [
      {
        label: <Entity entity="companyNotificationsBatteryOFF" />,
        value: COMPANY_NOTIFICATIONS_BATTERY_STATES.OFF,
      },
      {
        label: <Entity entity="companyNotificationsBatteryON" />,
        value: COMPANY_NOTIFICATIONS_BATTERY_STATES.ON,
      },
    ];
    const atlasOptions = [
      {
        label: <Entity entity="companyNotificationsAtlasOFF" />,
        value: COMPANY_NOTIFICATIONS_ATLAS_STATES.OFF,
      },
      {
        label: <Entity entity="companyNotificationsAtlasON" />,
        value: COMPANY_NOTIFICATIONS_ATLAS_STATES.ON,
      },
    ];
    const repeatOptions = [
      {
        label: <Entity entity="companyNotificationsRepeatOFF" />,
        value: COMPANY_NOTIFICATIONS_REPEAT_STATES.OFF,
      },
      {
        label: <Entity entity="companyNotificationsRepeatON" />,
        value: COMPANY_NOTIFICATIONS_REPEAT_STATES.ON,
      },
    ];
    const credentialsOptions = [
      {
        label: <Entity entity="companyNotificationsCredentialsOFF" />,
        value: COMPANY_NOTIFICATIONS_CREDENTIALS_STATES.OFF,
      },
      {
        label: <Entity entity="companyNotificationsCredentialsON" />,
        value: COMPANY_NOTIFICATIONS_CREDENTIALS_STATES.ON,
      },
    ];
    const elementsUsageOptions = [
      {
        label: <Entity entity="companyNotificationsElementsUsageOFF" />,
        value: COMPANY_NOTIFICATIONS_ELEMENTS_USAGE_STATES.OFF,
      },
      {
        label: <Entity entity="companyNotificationsElementsUsageON" />,
        value: COMPANY_NOTIFICATIONS_ELEMENTS_USAGE_STATES.ON,
      },
    ];
    
    const batteryLevelOptions = [
      {
        label: COMPANY_NOTIFICATIONS_BATTERY_LEVELS.L75,
        value: COMPANY_NOTIFICATIONS_BATTERY_LEVELS.L75,
      },
      {
        label: COMPANY_NOTIFICATIONS_BATTERY_LEVELS.L50,
        value: COMPANY_NOTIFICATIONS_BATTERY_LEVELS.L50,
      },
      {
        label: COMPANY_NOTIFICATIONS_BATTERY_LEVELS.L25,
        value: COMPANY_NOTIFICATIONS_BATTERY_LEVELS.L25,
      },
    ];
    
    const elementsUsageLevelOptions = [
      {
        label: COMPANY_NOTIFICATIONS_ELEMENTS_USAGE_LEVELS.L50,
        value: COMPANY_NOTIFICATIONS_ELEMENTS_USAGE_LEVELS.L50,
      },
      {
        label: COMPANY_NOTIFICATIONS_ELEMENTS_USAGE_LEVELS.L60,
        value: COMPANY_NOTIFICATIONS_ELEMENTS_USAGE_LEVELS.L60,
      },
      {
        label: COMPANY_NOTIFICATIONS_ELEMENTS_USAGE_LEVELS.L70,
        value: COMPANY_NOTIFICATIONS_ELEMENTS_USAGE_LEVELS.L70,
      },
      {
        label: COMPANY_NOTIFICATIONS_ELEMENTS_USAGE_LEVELS.L80,
        value: COMPANY_NOTIFICATIONS_ELEMENTS_USAGE_LEVELS.L80,
      },
      {
        label: COMPANY_NOTIFICATIONS_ELEMENTS_USAGE_LEVELS.L90,
        value: COMPANY_NOTIFICATIONS_ELEMENTS_USAGE_LEVELS.L90,
      },
    ];

    const gatewayNotificationON = form && form.values && form.values.gatewayMode === COMPANY_NOTIFICATIONS_GATEWAY_STATES.ON;
    const batteryNotificationON = form && form.values && form.values.batteryMode === COMPANY_NOTIFICATIONS_BATTERY_STATES.ON;
    const repeatNotificationON = form && form.values && form.values.repeatMode === COMPANY_NOTIFICATIONS_REPEAT_STATES.ON;
    const credentialsNotificationON = form && form.values && form.values.credentialsMode === COMPANY_NOTIFICATIONS_CREDENTIALS_STATES.ON;
    const elementsUsageNotificationON = form && form.values && form.values.elementsUsageMode === COMPANY_NOTIFICATIONS_ELEMENTS_USAGE_STATES.ON;

    const usersEnabled = platformUsersData.filter(e=>e.companyNotificationsEnabled);
    return (
      <Form style={formStyle} autoComplete="off">
        <div style={{ marginTop: 5, marginBottom: 25, marginLeft: 2 }}>
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
            <h2 style={{ color: '#3f3f3f', marginBottom: 0, marginTop:0, fontWeight: 'bold', fontSize: 25 }}><Entity entity="companyNotifications" /></h2>
            <CompanyReportIconCustom style={{ color: '#3f3f3f', width: 22, marginLeft: 5 }} />
          </div>
          <h4 style={{ color: '#3f3f3f' }}><Entity entity="companyNotificationsDescription" /></h4>
        </div>
        <FormFlatContainer
          title="companyNotificationsGateway"
          subtitle="companyNotificationsGatewayDescription"
          icon={<HyperGateIcon style={{ fontSize: 20, marginRight: 5 }} />}
          headerStyle={{ marginBottom: 0 }}
        >
          <div style={{ paddingLeft: 15, paddingRight: 25 }}>
            <Field
              name="gatewayMode"
              title={<Entity entity="deviceUUIDMode" />}
              component={MDRadioButtonsGroupField}
              containerstyle={{ paddingLeft: 15, marginTop: 0 }}
              showErrorLabel
              options={gatewayOptions}
            />
            {gatewayNotificationON ? (
              <div style={{ display: 'flex', flexDirection: 'row', paddingLeft: 0, pointerEvents: 'unset' }}>
                <h4 style={{ color: '#3f3f3f', marginRight: 10, marginTop: 11, fontSize:16 }}>{<Entity entity="companyNotificationsGatewayONdescription"/>}</h4>
                <Entity
                  componentClass={Field}
                  name="gatewayOfflineForMinutes"
                  type="number"
                  textFormattingFunction={value => value.replace(/[\s.]+/g, '')}
                  componentAttribute="placeholder"
                  showErrorLabel
                  component={CustomField}
                  containerStyle={{ width: 100 }}
                  className="form-control-custom"
                />
                <h4 style={{ color: '#3f3f3f', marginLeft: 10, marginTop: 11, fontSize:16 }}>{<Entity entity="minutes"/>}</h4>
              </div>
            ) : null}
          </div>
        </FormFlatContainer>

        <FormFlatContainer
          title="companyNotificationsBattery"
          subtitle="companyNotificationsBatteryDescription"
          icon={<SmartLocksIcon style={{ fontSize: 20, marginRight: 5 }} />}
          headerStyle={{ marginBottom: 0 }}
        >
          <div style={{ paddingLeft: 15, paddingRight: 25 }}>
            <Field
              name="batteryMode"
              title={<Entity entity="deviceUUIDMode" />}
              component={MDRadioButtonsGroupField}
              containerstyle={{ paddingLeft: 15, marginTop: 0 }}
              showErrorLabel
              options={batteryOptions}
            />
            {batteryNotificationON ? (
              <div style={{ display: 'flex', flexDirection: 'row', paddingLeft: 0, pointerEvents: 'unset' }}>
                <h4 style={{ color: '#3f3f3f', marginRight: 10, marginTop: 11, fontSize:16 }}>{<Entity entity="companyNotificationsBatteryONdescription"/>}</h4>
                <Field
                  id="smartLockBatteryLevelSelected"
                  name="smartLockBatteryLevelSelected"
                  title=""
                  component={CustomField}
                  className="form-control-select"
                  componentClass="select"
                >
                  {_.map(batteryLevelOptions, level =>
                    <option value={level.value} key={level.value}>
                      {level.value}
                    </option>
                  )}
                </Field>
              </div>
            ) : null}
          </div>
        </FormFlatContainer>

        {user && user.systemHasAtlas ? (
          <FormFlatContainer
            title="companyNotificationsAtlas"
            subtitle="companyNotificationsAtlasDescription"
            icon={<AtlasIcon style={{ fontSize: 20, marginRight: 5 }} />}
            headerStyle={{ marginBottom: 0 }}
          >
            <div style={{ paddingLeft: 15, paddingRight: 25 }}>
              <Field
                name="atlasMode"
                title={<Entity entity="deviceUUIDMode" />}
                component={MDRadioButtonsGroupField}
                containerstyle={{ paddingLeft: 15, marginTop: 0 }}
                showErrorLabel
                options={atlasOptions}
              />
            </div>
          </FormFlatContainer>
        ) : null}

        <FormFlatContainer
          title="companyNotificationsCredentials"
          subtitle="companyNotificationsCredentialsDescription"
          icon={<GuestCredentialIconCustom style={{ fontSize: 20, width: 20, marginRight: 5 }} />}
          headerStyle={{ marginBottom: 0 }}
        >
          <div style={{ paddingLeft: 15, paddingRight: 25 }}>
            <Field
              name="credentialsMode"
              title={<Entity entity="deviceUUIDMode" />}
              component={MDRadioButtonsGroupField}
              containerstyle={{ paddingLeft: 15, marginTop: 0 }}
              showErrorLabel
              options={credentialsOptions}
            />
            {credentialsNotificationON ? (
              <div style={{ display: 'flex', flexDirection: 'row', paddingLeft: 0, pointerEvents: 'unset' }}>
                <h4 style={{ color: '#3f3f3f', marginRight: 10, marginTop: 11, fontSize:16 }}>{<Entity entity="companyNotificationsCredentialsONdescription"/>}</h4>
                <Entity
                  componentClass={Field}
                  name="credentialsWillExpireInHours"
                  type="number"
                  textFormattingFunction={value => value.replace(/[\s.]+/g, '')}
                  componentAttribute="placeholder"
                  showErrorLabel
                  component={CustomField}
                  containerStyle={{ width: 100 }}
                  className="form-control-custom"
                />
                <h4 style={{ color: '#3f3f3f', marginLeft: 10, marginTop: 11, fontSize:16 }}>{<Entity entity="days"/>}</h4>
              </div>
            ) : null}
          </div>
        </FormFlatContainer>

        <FormFlatContainer
          title="companyNotificationsElementsUsage"
          subtitle="companyNotificationsElementsUsageDescription"
          icon={<WalletIconCustom style={{ width: 20, marginRight: 5 }} />}
          headerStyle={{ marginBottom: 0 }}
        >
          <div style={{ paddingLeft: 15, paddingRight: 25 }}>
            <Field
              name="elementsUsageMode"
              title={<Entity entity="deviceUUIDMode" />}
              component={MDRadioButtonsGroupField}
              containerstyle={{ paddingLeft: 15, marginTop: 0 }}
              showErrorLabel
              options={elementsUsageOptions}
            />
            {elementsUsageNotificationON ? (
              <div style={{ display: 'flex', flexDirection: 'row', paddingLeft: 0, pointerEvents: 'unset' }}>
                <h4 style={{ color: '#3f3f3f', marginRight: 10, marginTop: 11, fontSize:16 }}>{<Entity entity="companyNotificationsElementsUsageONdescription"/>}</h4>
                <Field
                  id="elementsUsageLevelSelected"
                  name="elementsUsageLevelSelected"
                  title=""
                  component={CustomField}
                  className="form-control-select"
                  componentClass="select"
                >
                  {_.map(elementsUsageLevelOptions, level =>
                    <option value={level.value} key={level.value}>
                      {level.value}
                    </option>
                  )}
                </Field>
              </div>
            ) : null}
          </div>
        </FormFlatContainer>

        <FormFlatContainer
          title="companyNotificationsRepeat"
          subtitle="companyNotificationsRepeatDescription"
          icon={<RepeatIcon style={{ fontSize: 20, marginRight: 5 }} />}
          headerStyle={{ marginBottom: 0 }}
        >
          <div style={{ paddingLeft: 15, paddingRight: 25 }}>
            <Field
              name="repeatMode"
              title={<Entity entity="deviceUUIDMode" />}
              component={MDRadioButtonsGroupField}
              containerstyle={{ paddingLeft: 15, marginTop: 0 }}
              showErrorLabel
              options={repeatOptions}
            />
            {repeatNotificationON ? (
              <div style={{ display: 'flex', flexDirection: 'row', paddingLeft: 0, pointerEvents: 'unset' }}>
                <h4 style={{ color: '#3f3f3f', marginRight: 10, marginTop: 11, fontSize:16 }}>{<Entity entity="companyNotificationsRepeatONdescription"/>}</h4>
                <Entity
                  componentClass={Field}
                  name="sameNotificationAfterHours"
                  type="number"
                  textFormattingFunction={value => value.replace(/[\s.]+/g, '')}
                  componentAttribute="placeholder"
                  showErrorLabel
                  component={CustomField}
                  containerStyle={{ width: 100 }}
                  className="form-control-custom"
                />
                <h4 style={{ color: '#3f3f3f', marginLeft: 10, marginTop: 11, fontSize:16 }}>{<Entity entity="hours"/>}</h4>
              </div>
            ) : null}
          </div>
        </FormFlatContainer>

        <FormFlatContainer 
          title="companyNotificationsUsers" 
          subtitle="companyNotificationsUsersSubtitle"
          icon={<GuestGroupIcon style={{ fontSize: 20, marginRight: 5 }} />}
        >
          <div style={{ marginTop: 20 }}>
            <FieldArray
              name={`emails`}
              component={onRenderEmails}
              formData={formData}
              form={form}
              disabled={false}
              usersOptions={usersOptions}
              onInitializeNewEmail={emailId => this.onInitializeNewEmail(emailId, `emails`)}
            />
          </div>
          {/* OLD notified users management
          <div style={{ opacity: loading ? 0.7 : 1, pointerEvents: loading ? 'none' : 'unset' }}>
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
              <Field
                name="userSelectedSearch"
                component={SelectableField}
                noCache
                options={usersOptions}
                placeholder={<Entity entity="findGuestToAdd" />}
                containerstyle={{ minWidth: 480, marginRight: 10, zIndex:0 }}
                onInputChange={value => this.onFilterUsers(value)}
                onSelect={tagData => this.onSelectUser(tagData)}
              />
              <MDButton
                disabled={!userSelected}
                title={<Entity entity="addGuestToTag" />}
                style={{ borderRadius: 5 }}
                onClick={() => this.onAddOrRemoveUser(userSelected,true)}
              />
            </div>
            {!_.isEmpty(usersEnabled) ? (
              <div style={{ padding: 5, backgroundColor: '#f1f1f1', borderRadius: 10 }}>
                <div style={{ maxHeight: 400, padding: 5, overflowY: 'scroll' }}>
                  <InfiniteScroll
                    pageStart={0}
                    useWindow={false}
                    initialLoad={false}
                    loadMore={null}
                    hasMore={false}
                    loader={<ListLoadingView containerStyle={{ backgroundColor: 'transparent' }} />}
                  >
                    <div style={{ paddingTop: 5, paddingBottom: 5 }}>
                      {_.map(usersEnabled, (item, index) => (
                        <div key={item.id}>
                          <div
                            style={{ backgroundColor: index % 2 === 0 ? 'white' : 'ghostwhite', borderBottom: '1px solid', borderTop: '1px solid', alignItems: 'center', justifyContent: 'space-between', display: 'flex', padding: 5, borderColor: '#f0f0f0' }}
                            key={item.id}
                          >
                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                              <h5 style={{ color: '#3f3f3f', marginLeft: 10 }}>{`${item.firstname} ${item.lastname} ${isUserWithoutEmail(item) ? '': ` - ${item.email}`}`}</h5>
                            </div>
                            <IconButton
                              style={{ color: RED }}
                              onClick={() => this.onAddOrRemoveUser(item,false)}
                            >
                              <DeleteIcon style={{ fontSize: 20 }} />
                            </IconButton>
                          </div>
                        </div>
                      ))}
                    </div>
                  </InfiniteScroll>
                </div>
              </div>
            ) : (
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                <GuestGroupIcon style={{ color: '#3f3f3f', marginTop: 3, fontSize: 35 }} />
                <h4 style={{ color: '#3f3f3f', textAlign: 'center' }}>
                  <Entity entity={'noGuestsInList'} />
                </h4>
              </div>
            )}
          </div>
          */}
        </FormFlatContainer>
      </Form>
    );
  }
} 

export default SystemStatusReportForm;
